import { HTTPClient, HTTPMethod, HTTPResponse } from "@/core/common/communication/HTTPClient";
import { INVALID_CREDENTIALS, INVALID_RECAPTCHA } from "@/core/common/utils/ResourceStrings";
import { Login } from "../domain/Login";
import { LoginResponse } from "../domain/LoginResponse";

interface APILoginData {
  authSuccess: boolean;
  userId: string;
}

interface APIResponse<T> {
  result?: boolean;
  data?: T;
  detail?: string | object;
}

export class LoginImpl extends Login {
  private httpClient: HTTPClient;
  constructor(httpClient: HTTPClient) {
    super();
    this.httpClient = httpClient;
  }

  public async doLogout(): Promise<boolean> {
    const httpResponse: HTTPResponse = await this.httpClient.send(HTTPMethod.POST, "/api/auth/logout", {});

    return Promise.resolve(httpResponse.success);
  }

  public async restoreSession(): Promise<LoginResponse> {
    const httpResponse: HTTPResponse = await this.httpClient.send(HTTPMethod.POST, "/api/auth/refresh", {});
    return Promise.resolve(this.mapAuthResponse(httpResponse, false));
  }

  public async doLogin(mail: string, password: string, _captchaToken: string): Promise<LoginResponse> {
    const httpResponse: HTTPResponse = await this.httpClient.send(HTTPMethod.POST, "/api/auth/login", {
      mail,
      password,
      captchaToken: _captchaToken
    });

    return Promise.resolve(this.mapAuthResponse(httpResponse, true));
  }

  private mapAuthResponse(httpResponse: HTTPResponse, showAuthErrors: boolean): LoginResponse {
    const result = {} as LoginResponse;

    if (httpResponse.success) {
      const apiResponse = httpResponse.data as APIResponse<APILoginData>;
      if (apiResponse.result && apiResponse.data?.authSuccess) {
        result.success = true;
        result.errorMsg = "";
        result.userId = apiResponse.data.userId;
      } else {
        result.success = false;
        result.errorMsg = INVALID_CREDENTIALS;
        result.userId = "";
      }
    } else {
      result.success = false;
      result.errorMsg = !showAuthErrors
        ? ""
        : httpResponse.errorMsg.includes("Invalid recaptcha")
        ? INVALID_RECAPTCHA
        : httpResponse.errorMsg.includes("401")
        ? INVALID_CREDENTIALS
        : httpResponse.errorMsg;
      result.userId = "";
    }

    return result;
  }
}
